'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDangerNotification = createDangerNotification;
exports.createInfoNotification = createInfoNotification;
exports.createSuccessNotification = createSuccessNotification;
exports.createTipNotification = createTipNotification;
exports.createWarningNotification = createWarningNotification;
function createNotification(_ref) {
  var type = _ref.type,
      titleText = _ref.titleText,
      message = _ref.message,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === undefined ? false : _ref$sticky;

  return {
    type: type,
    titleText: titleText,
    message: message,
    sticky: sticky
  };
}

function createDangerNotification(titleText, message, sticky) {
  return createNotification({ type: 'danger', titleText: titleText, message: message, sticky: sticky });
}

function createInfoNotification(titleText, message, sticky) {
  return createNotification({ type: 'info', titleText: titleText, message: message, sticky: sticky });
}

function createSuccessNotification(titleText, message, sticky) {
  return createNotification({ type: 'success', titleText: titleText, message: message, sticky: sticky });
}

function createTipNotification(titleText, message, sticky) {
  return createNotification({ type: 'tip', titleText: titleText, message: message, sticky: sticky });
}

function createWarningNotification(titleText, message, sticky) {
  return createNotification({ type: 'warning', titleText: titleText, message: message, sticky: sticky });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.618/js/utils.js
// module id = 472
// module chunks = 0